export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/ef6fc1e4-8111-4f5d-845e-fd6348221166.png" 
                alt="Лучшие казино онлайн" 
                className="w-12 h-12 object-contain"
              />
              <span className="text-xl font-bold">Бонусы Казино</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Независимый анализ лучших казино онлайн с бонусами. Помогаем выбрать самые выгодные предложения с 2024 года.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Популярные разделы</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#top-casinos" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Рейтинг казино онлайн
                </a>
              </li>
              <li>
                <a href="#calculator" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Калькулятор вейджера
                </a>
              </li>
              <li>
                <a href="#top-casinos" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Бездепозитные бонусы
                </a>
              </li>
              <li>
                <a href="#top-casinos" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Программы кешбэка
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Казино онлайн</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://fugu-way-one.com/c763d5df9" target="_blank" rel="nofollow sponsored noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Fugu Casino
                </a>
              </li>
              <li>
                <a href="https://sol-blsm10.com/c26114c36" target="_blank" rel="nofollow sponsored noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors">
                  SOL Casino
                </a>
              </li>
              <li>
                <a href="https://fresh-blrs10.com/cf443d7fa" target="_blank" rel="nofollow sponsored noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors">
                  FRESH Casino
                </a>
              </li>
              <li>
                <a href="https://lexyway1.com/c737609d2" target="_blank" rel="nofollow sponsored noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors">
                  LEX Casino
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Информация</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">Обновлено: Январь 2026</li>
              <li className="text-gray-400">Проверенных казино: 15+</li>
              <li className="text-gray-400">Актуальных бонусов: 50+</li>
            </ul>
            <div className="mt-4 flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-telegram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="bg-yellow-900/30 border border-yellow-700/50 rounded-xl p-6 mb-8">
            <div className="flex items-start gap-3">
              <i className="ri-error-warning-line text-2xl text-yellow-400 mt-1"></i>
              <div className="text-sm text-gray-300 leading-relaxed">
                <strong className="text-yellow-400">Важное уведомление (18+):</strong> Бонусные условия казино онлайн могут изменяться. Всегда проверяйте актуальные условия на сайте выбранного казино перед активацией бонуса. Азартные игры могут вызывать зависимость. Играйте ответственно. Если вы или ваши близкие столкнулись с проблемой игровой зависимости, обратитесь за помощью к специалистам.
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2026 Лучшие Казино Онлайн с Бонусами. Все права защищены.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-orange-400 transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}